import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';
import './App.css';  // This should come first (if it's from create-react-app template)
import './styles.css';  // Your custom styles

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(<App />);
